import React, { useState } from 'react';
import ListDropdown from './list-dropdown.tsx';
import { Configuration } from '../../data/configuration.ts';
import { CloudData } from '../../data/cloud-data.js';

//-----------------------------------------------------------------------------------------
// Public Components:
//-----------------------------------------------------------------------------------------

export default function RegionSelector() {

	// states.

	const [isOpen, setIsOpen] = useState(false);

	// handlers.

	const handleRegionSelected = (regionCode: string) => {

		// update the region code in the URL.
		const url = new URL(window.location.href);
		url.searchParams.set('region', regionCode);
		window.location.href = url.toString();
	}

	// return the HTML.
	return (
		<React.Fragment>
			<div className="region-selector-trigger" onClick={() => setIsOpen(true)}>
				<img className="list-item-image" src={`assets/images/icons/region-code-flags/${Configuration.regionCode}.svg`} width="25" height="25" alt="Region Flag" />
				<p>{Configuration.regionCode.toUpperCase()}</p>
			</div>
			{isOpen && (
				<div className="region-selector-overlay">
					<div className="select-region-header">
						<img src="assets/images/logo/morgan-full-logo-white.svg" width="120" height="53" alt="Morgan Motor Company Logo" />
						<p>BETA</p>
					</div>
					<div className="summary-content">
						<ListDropdown
							title="SELECT COUNTRY"
							alwaysOpen={true}
							selectedItem={Configuration.regionCode}
							handleItemSelected={handleRegionSelected}
							listOptions={CloudData.supportedRegions.map(region => ({
								id: region.id,
								name: region.name,
								imageFilePath: `assets/images/icons/region-code-flags/${region.id}.svg`
							}))}
						/>
					</div>
					<div className="footer">
						<button id="back-btn" onClick={() => setIsOpen(false)}>BACK</button>
					</div>
				</div>
			)}
		</React.Fragment>
	);
}
